import React from "react";
import { Badge } from "@mantine/core";
import EmployeeStatusBadgeStyles from "../assets/EmployeeStatusBadgeStyles";

type EmployeeStatusBadgeProps = {
  status: string;
};

const EmployeeStatusBadge: React.FC<EmployeeStatusBadgeProps> = ({
  status,
}) => {
  const { classes, cx } = EmployeeStatusBadgeStyles();

  switch (status) {
    case "active":
      return (
        <Badge
          size="sm"
          style={{ backgroundColor: "rgba(29, 209, 156, 0.1)" }}
          className={cx(classes.label, classes.active)}
        >
          {status}
        </Badge>
      );
    case "deleted":
      return (
        <Badge
          size="sm"
          style={{ backgroundColor: "rgba(49, 160, 178, 0.1)" }}
          className={classes.label}
        >
          {status}
        </Badge>
      );
    default:
      return (
        <Badge
          style={{
            backgroundColor: "#e7e9eb",
          }}
          className={classes.label}
        >
          {status}
        </Badge>
      );
  }
};

export default EmployeeStatusBadge;
